module.exports = __webpack_public_path__ + "static/buehne_ueber-uns-6e7806f364ae4be2fc25e394412e3c45.svg";